export const Types = {
  loading: 'loading',
  saving: 'saving',
  removing: 'removing',
  finished: 'finished',
  errors: 'errors',
  dialog: 'dialog',
  none: 'none',
  clone: 'clone',
  saved: 'saved',
  to: 'to',
  message: 'message',
  title: 'title',
  button: 'button',
  controller: 'controller',
  scrollHeight: 'scrollHeight',
  offsetHeight: 'offsetHeight',
  scrollTop: 'scrollTop',
  checkin: 'checkin',
  withdraw: 'withdraw'
}

export const path = 'data/'

export class Loading implements FluxStandardAction<boolean> {
  type = path + Types.loading
  constructor(public payload: boolean) {}
}

export class Saving implements FluxStandardAction<boolean | null> {
  type = path + Types.saving
  constructor(public payload: boolean | null) {}
}

export class Removing implements FluxStandardAction<boolean | null> {
  type = path + Types.removing
  constructor(public payload: boolean | null) {}
}

export class Finished implements FluxStandardAction<boolean | string | null> {
  type = path + Types.finished
  constructor(public payload: boolean | string | null) {}
}

export class Errors implements FluxStandardAction<any> {
  type = path + Types.errors
  constructor(public payload: any) {}
}

export class Dialog implements FluxStandardAction<boolean | null> {
  type = path + Types.dialog
  constructor(public payload: boolean | null) {}
}

export class None implements FluxStandardAction<boolean | null> {
  type = path + Types.none
  constructor(public payload: boolean | null) {}
}

export class Clone implements FluxStandardAction<any> {
  type = path + Types.clone
  constructor(public payload: any) {}
}

export class Saved implements FluxStandardAction<boolean> {
  type = path + Types.saved
  constructor(public payload: boolean) {}
}

export class To implements FluxStandardAction<any> {
  type = path + Types.to
  constructor(public payload: any) {}
}

export class Message implements FluxStandardAction<string> {
  type = path + Types.message
  constructor(public payload: string) {}
}

export class Title implements FluxStandardAction<string> {
  type = path + Types.title
  constructor(public payload: string) {}
}

export class Button implements FluxStandardAction<string> {
  type = path + Types.button
  constructor(public payload: string) {}
}

export class Controller implements FluxStandardAction<{ [id: string]: AbortController | null } | null> {
  type = path + Types.controller
  constructor(public payload: { [id: string]: AbortController | null } | null) {}
}

export class ScrollHeight implements FluxStandardAction<number | null> {
  type = path + Types.scrollHeight
  constructor(public payload: number | null) {}
}

export class OffsetHeight implements FluxStandardAction<number | null> {
  type = path + Types.offsetHeight
  constructor(public payload: number | null) {}
}

export class ScrollTop implements FluxStandardAction<number | null> {
  type = path + Types.scrollTop
  constructor(public payload: number | null) {}
}

export class Checkin implements FluxStandardAction<boolean> {
  type = path + Types.checkin
  constructor(public payload: boolean) {}
}

export class Withdraw implements FluxStandardAction<boolean> {
  type = path + Types.withdraw
  constructor(public payload: boolean) {}
}
